import React, { useState } from 'react';
import { func, string, object } from 'prop-types';
import { reportToSegment, types, eventNames } from '@smartcar/morse';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { withRouter } from 'react-router-dom';

import Modal from '../Modal';
import staticText from '../../localization/Components/upsellModal';
import image from '../../assets/images/free.png';
import { featureSetName } from '../../services/featureGate';
import HubspotForm from '../HubspotFormModal/HubspotForm/HubspotForm';
import { hubspotFormConfigs } from '../HubspotFormModal/hubspotFormConfigs';

export const handleUpgradeClick = ({
  feature, history, toggleModal,
}) => {
  const billingPath = '/team/billing';
  reportToSegment(types.TRACK, eventNames.linkClicked, {
    section: 'article',
    style: 'cta primary',
    text: `upsell (${feature})`,
    path: billingPath,
  });
  history.push(billingPath);
  if (toggleModal) toggleModal();
};

const UpsellModal = ({
  toggleModal, feature, history, featureSetId,
}) => {
  const theme = useTheme();
  const [contactFormOpen, setContactFormOpen] = useState(false);

  const planName = featureSetName(featureSetId);
  const highestPlan = planName === 'enterprise';

  const handleContactUs = () => {
    reportToSegment(types.TRACK, eventNames.buttonClicked, {
      label: 'chat',
      text: `[${feature}] ${staticText.reachedLimit.primaryCta}`,
    });
    setContactFormOpen(true);
  };

  const renderInnerContent = () => {
    if (contactFormOpen) {
      return (
        <HubspotForm
          onSubmit={() => toggleModal()}
          formConfig={hubspotFormConfigs.contactUs}
          prefill
        />
      );
    }

    return (
      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        <Box width="200px" margin="0 auto" sx={{ img: { width: '100%' } }}>
          <img src={image} alt="" />
        </Box>
        {highestPlan ? (
          <React.Fragment>
            <Typography>{staticText.reachedLimit.body(feature)}</Typography>
            <Button
              id="contact-us"
              variant="outlined"
              color="warning"
              onClick={handleContactUs}
            >
              {staticText.reachedLimit.primaryCta}
            </Button>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Typography>{staticText[feature].body}</Typography>
            <Button
              variant="outlined"
              color="warning"
              onClick={() => handleUpgradeClick({
                feature, history, toggleModal,
              })}
              id="upgrade-now"
            >
              {staticText.upgrade}
            </Button>
          </React.Fragment>
        )}
      </Box>
    );
  };

  const content = (
    <Box textAlign="center" marginTop={theme.spacing(1)} marginBottom={theme.spacing(3)}>
      {renderInnerContent()}
    </Box>
  );

  // eslint-disable-next-line no-nested-ternary
  const title = contactFormOpen ?
    staticText.reachedLimit.contactFormTitle : highestPlan ?
      staticText.reachedLimit.title : staticText.title;

  return (<Modal
    title={title}
    toggleModal={toggleModal}
    content={content}
  />);
};

UpsellModal.propTypes = {
  toggleModal: func.isRequired,
  feature: string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  history: object.isRequired,
  featureSetId: string.isRequired,
};

export default withRouter(UpsellModal);
